// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  apiVersion: 'v1.0',
  apiUrl: 'https://dev.myvetbusiness.it/',

  firebase: {
    apiKey: 'AIzaSyDMKpXwkjHIezKy5ae2bUi_AUb46fcNQao',
    authDomain: 'myvet-383716.firebaseapp.com',
    projectId: 'myvet-383716',
    storageBucket: 'myvet-383716.appspot.com',
    messagingSenderId: '48835804057',
    appId: '1:48835804057:web:228de82963aec643b37108',
    vapidKey:
      'BO-hrtEMm3QrvLwlbdgnUE1haSYql1O_TtaQS8sbaiMCZk7Ea-4BBhn8AP0u0oJIejxShBgs7zNbXSy-7i-Utc4',
  },

  izs: {
    clientId: 'Z90qVrQBce',
    oAuthUrl: 'https://test.vetinfo.it/j_test_auth/',
    scope: 'FAR',
    clientSecret: 'c5601383-8bd6-40d8-870d-a1a872feec1c',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
